export interface SubscriptionItem {
  productName: string;
  productTrial: boolean;
  productSKU: string;
}

export interface SubscriptionInfo {
  node: {
    active: boolean;
    willExpireAt: Date;
    items: SubscriptionItem[];
  };
}

export interface CloudLynk {
  id: string;
  imei: string;
  iccid: string;
  type: string;
  serialNumber: string;
  unlockCodeId?: string;
  company: {
    id: string;
    name: string;
  };
}

export enum ProductSubscriptions {
  FEED_FARMER = 'Farmer',
  FEED_LITE = 'Lite',
  FEED_PRO = 'Pro',
  FEED_FEEDLOT = 'FEEDlot',
}
